import { useSelector } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'

import AuthenticationRenewal from 'authentication/shared/components/AuthenticationRenewal'
import EnvironmentAlert from 'infrastructure/Application/components/EnvironmentAlert'

import { Loading, Router as ApplicationRouter } from './components'
import { useToken, useHandleLanguage } from 'shared/hooks'

type ReduxState = { api: { isPending: boolean } }

const ApplicationContainer = () => {
  const isLoading = useSelector((state: ReduxState) => state.api?.isPending)

  useToken()
  useHandleLanguage()

  return (
    <>
      <Loading active={isLoading} />
      <EnvironmentAlert environment={window.waEnv} />
      <AuthenticationRenewal />
      <ApplicationRouter />
      <ToastContainer
        position={toast.POSITION.BOTTOM_CENTER}
        pauseOnFocusLoss={false}
        pauseOnHover={false}
      />
    </>
  )
}

export default ApplicationContainer
